import { useTheme } from '@mui/material/styles';

const useOurDarkMode = () => {
  const theme = useTheme();

  return theme.palette.mode === 'dark';
};

export default useOurDarkMode;
